import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";

function Mockupone() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const mockupImages = [
  { id: 1, url: "/assets/r1.PNG", alt: "Mockup 1" },
  { id: 2, url: "/assets/r2.PNG", alt: "Mockup 2" },
  { id: 3, url: "/assets/r3.PNG", alt: "Mockup 3" },
];


  return (
    <Container
      fluid
      className="container-section"
      style={{
        backgroundColor: "#212020",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: isSmallScreen ? "auto" : "100vh",
        paddingBottom: isSmallScreen ? "2rem" : "0rem",
        
      }}
    >
      <Row
        className="justify-content-center "
        style={{ textAlign: "center", rowGap: isSmallScreen ? "2rem" : "0", width:"100%"  }}
      >
     {mockupImages.map((image) => (
          <Col
            xs={12}
            md={4}
            lg={3}
            key={image.id}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Image
              src={image.url}
              alt={image.alt}
              style={{
                maxWidth: "100%",
                height: "auto",
                borderRadius: "8px",
              }}
            />
          </Col>
        ))}
      </Row>
     
    </Container>
  );
}

export default Mockupone;
